import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

export const LOC_CREATE_STAGES = {
  LOCATION_DETAILS: 1,
  CONTACT_INFO: 2,
  PLAN_PICKER: 3,
  PRICING_CALCULATOR: 4,
  DEMOGRAPHIC_DETAILS: 5,
  CONFIRM: 6,
};

/**
 * Basic layout for the LocationCreation flow
 */
function LocationCreation({ welcomeHeading }) {
  return (
    <Container className="mb-5">
      <div className="my-5">
        {welcomeHeading}
      </div>
      <div className="border rounded-3">
        <Outlet />
      </div>
    </Container>
  );
}

LocationCreation.propTypes = {
  welcomeHeading: PropTypes.node,
};

LocationCreation.defaultProps = {
  welcomeHeading: null,
};

export default LocationCreation;
